import React from 'react';

import TextFieldBase from 'components/mui/Form/TextField/TextFieldBase';

import TextFieldTrim from './TextFieldTrim';
import HelperTextError from 'components/mui/Form/TextField/HelperTextError';

const TextFieldForm = ({ input, meta, withTrim, ...rest }) => {
  const isError = Boolean(meta.touched && meta.error);
  const TextField = withTrim ? TextFieldTrim : TextFieldBase;

  return (
    <TextField
      error={isError}
      variant="outlined"
      helperText={<HelperTextError isError={isError} meta={meta} />}
      {...input}
      {...rest}
    />
  );
};

export default TextFieldForm;
